<template>
  <MainLayout>
    <div class="reset-password-page">
      <v-card class="reset-password-card">
        <v-container class="login-form">
          <v-layout fill-weight column class="mx-5">
            <v-layout
              align-center
              column
              class="mt-2"
              style="margin-bottom: 2.5em"
            >
              <!-- <img
                style="width: 100%"
                src="@/assets/images/uplabdh_logo_clear.png"
              /> -->
            </v-layout>

            <v-form ref="resetPasswordForm" lazy-validation>
              <!-- Password -->
              <v-text-field
                type="password"
                outline
                prepend-inner-icon="lock"
                v-model="resetPasswordForm.password"
                hint="Password must be at least 8 characters"
                :rules="rules.password"
                label="Password"
                single-line
                :error-messages="errors.password"
              />

              <!-- Confirm Password -->
              <v-text-field
                type="password"
                outline
                prepend-inner-icon="lock"
                v-model="resetPasswordForm.password_confirmation"
                hint="Password must be at least 8 characters"
                :rules="rules.password"
                label="Password Confirmation"
                single-line
                :error-messages="errors.password"
              />

              <!-- Submit -->
              <v-btn
                class="reset-password-button"
                :loading="loading"
                color="primary"
                dark
                large
                depressed
                @click="submitForm('resetPasswordForm')"
                style="margin: 0"
              >
                Update Password
              </v-btn>
            </v-form>
          </v-layout>
        </v-container>
      </v-card>
    </div>
  </MainLayout>
</template>

<script>
import api from "@/api";

export default {
  metaInfo: {
    title: "Reset Password",
    meta: [{ name: "description", content: `Reset Password` }]
  },

  data() {
    return {
      resetPasswordForm: {
        email: atob(this.$route.params.email),
        token: this.$route.params.token,
        password: "",
        password_confirmation: ""
      },

      loading: false,
      errors: {},

      rules: {
        password: [
          v => !!v || "Password is required",
          v => v.length >= 8 || "Password must be at least 8 characters"
        ]
      }
    };
  },

  methods: {
    submitForm(formName) {
      if (this.$refs[formName].validate()) {
        this.requestResetPassword(this.resetPasswordForm);
      }
    },

    async requestResetPassword(req) {
      this.loading = true;

      try {
        this.loading = true;
        this.errors = {};

        const res = await api.resetPassword(req);

        this.$notify({
          type: "success",
          title: res.data.message
        });
      } catch (error) {
        if (error.errors) {
          this.errors = error.errors;
        } else {
          this.$notify({
            type: "error",
            title: error.message
          });
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="css" scoped>
.reset-password-page {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.reset-password-card {
  width: 30em;
  margin-top: 1.875em;
}

@media (max-width: 600px) {
  .reset-password-card {
    width: 90%;
  }
}

.reset-password-button {
  width: 100%;
}
</style>
